module.exports = __webpack_public_path__ + "static/img/product_banner_30_zh.d992981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_30_zh.png
// module id = 1hA4
// module chunks = 34